
import ListComponent from "../../../components/asset_loser_items/Index.vue";

export default {
  components: {
    ListComponent,
  },
};
